import { render, staticRenderFns } from "./AddFleet.vue?vue&type=template&id=15fa4dcc&scoped=true"
import script from "./AddFleet.vue?vue&type=script&lang=js"
export * from "./AddFleet.vue?vue&type=script&lang=js"
import style0 from "./AddFleet.vue?vue&type=style&index=0&id=15fa4dcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fa4dcc",
  null
  
)

export default component.exports